<template>
	<ShareButton
		:classes="{'mail-button': true}"
		:link="link"
		platform="E-Mail"
	>
		<template #icon>
			<Icon
				icon-name="mail"
				size="lg"
			/>
		</template>
	</ShareButton>
</template>

<script>
import ShareButton from './ShareButton';
import Icon from '@components/Icon';

export default {
	name:       'MailShareButton',
	components: { ShareButton, Icon },
	props:      {
		link: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.mail-button::v-deep {
	background-color: var(--color-hype-yellow);
	border-color: var(--color-hype-yellow);
	color: var(--color-text-on-hype-yellow);
}
</style>
